import React, { useState, useEffect, useCallback } from "react";
import { BiLogOut } from "react-icons/bi";
import {
  FaBars,
  FaChartBar,
  FaBook,
  FaListAlt,
  FaExchangeAlt,
  FaArrowRight,
  FaArrowDown,
  FaUsers,
  FaTag,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';

const LayoutUser = ({ title, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userName, setUserName] = useState("Pengguna");
  const [profileImageUrl, setProfileImageUrl] = useState(null);

  const fetchProfile = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const userId = decoded.id;

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/anggota/${userId}`, {
        headers: { 'x-auth-token': token },
      });

      const data = response.data;
      setUserName(data.nama_lengkap);
      if (data.foto_profile) {
        setProfileImageUrl(`${process.env.REACT_APP_BASE_URL}${data.foto_profile}`);
      } else {
        setProfileImageUrl(null);
      }

    } catch (error) {
      console.error('Gagal memuat data profil:', error);
    }
  }, [navigate]);

  useEffect(() => {
    const isDesktop = window.innerWidth >= 1024;
    setIsSidebarOpen(isDesktop);
    const path = location.pathname;
    if (path.includes("dashboard-user")) setActiveMenu("dashboard-user");
    else if (path.includes("koleksi-buku")) setActiveMenu("koleksi-buku");
    else if (path.includes("pinjam-buku")) setActiveMenu("pinjam-buku");
    else if (path.includes("leaderboard")) setActiveMenu("leaderboard");
    else if (path.includes("profile")) setActiveMenu("profile");

    // Panggil fungsi fetchProfile di sini
    fetchProfile();
  }, [location.pathname, navigate, fetchProfile]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div
      className="layout-wrapper"
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f5f5f5",
      }}
    >
      {/* Top Navigation Bar */}
      <nav
        className="navbar is-info"
        role="navigation"
        aria-label="main navigation"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 10,
          background: "#209CEE",
        }}
      >
        <div
          className="navbar-brand is-flex is-align-items-center"
          style={{ width: "100%" }}
        >
          {/* Burger menu hanya tampil di mobile */}
          <button
            className="navbar-item is-hidden-desktop"
            onClick={toggleSidebar}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              cursor: "pointer",
            }}
          >
            <FaBars />
          </button>
          <p
            className="navbar-item is-size-5 has-text-white"
            style={{ fontWeight: "bold" }}
          >
            Perpustakaan
          </p>
        </div>
      </nav>

      <div style={{ display: "flex", flexGrow: 1, marginTop: "52px" }}>
        {/* Left Sidebar */}
        <aside
          className={`sidebar ${isSidebarOpen ? "" : "is-hidden-mobile"}`}
          style={{
            width: isSidebarOpen ? "220px" : "0",
            background: "#364150",
            color: "white",
            overflow: "hidden",
            transition: "width 0.3s ease-in-out",
          }}
        >
          {/* Profil Anggota */}
          <div
            style={{
              padding: "1rem",
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            {profileImageUrl ? (
              <img
                src={profileImageUrl}
                alt="User"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  marginRight: "10px",
                  border: "2px solid #fff",
                  boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                  objectFit: "cover",
                }}
              />
            ) : (
              <FaUsers
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  marginRight: "10px",
                  border: "2px solid #fff",
                  boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                  color: "white",
                }}
              />
            )}
            <p style={{ fontWeight: "bold" }}>{userName}</p>
          </div>

          <ul style={{ listStyle: "none", padding: 0, marginTop: "1rem" }}>
            {/* Dashboard */}
            <li
              className={`menu-item ${activeMenu === "dashboard-user" ? "is-active" : ""
                }`}
              style={{
                padding: "8px",
                marginBottom: "5px",
                background:
                  activeMenu === "dashboard-user"
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
              }}
            >
              <Link
                to="/dashboard-user"
                style={{ textDecoration: "none", color: "white" }}
              >
                <FaChartBar style={{ marginRight: "5px" }} />
                Dashboard
              </Link>
            </li>

            {/* Koleksi Buku */}
            <li
              className={`menu-list ${activeMenu === "koleksibuku" ? "is-active" : ""
                }`}
              style={{
                padding: "8px",
                marginBottom: "5px",
                background:
                  activeMenu === "koleksibuku"
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
              }}
            >
              <Link
                to="/koleksibuku"
                style={{ textDecoration: "none", color: "white" }}
              >
                <FaBook style={{ marginRight: "5px" }} /> Koleksi Buku
              </Link>
            </li>

            {/* Peminjaman Buku */}
            <li
              className={`menu-list ${activeMenu === "PeminjamanBuku" ? "is-active" : ""
                }`}
              style={{
                padding: "8px",
                marginBottom: "5px",
                background:
                  activeMenu === "PeminjamanBuku"
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
              }}
            >
              <Link
                to="/PeminjamanBuku"
                style={{ textDecoration: "none", color: "white" }}
              >
                <FaBook style={{ marginRight: "5px" }} /> Peminjaman Buku
              </Link>
            </li>

            {/* Leaderboard */}
            <li
              className={`menu-item ${activeMenu === "leaderboard" ? "is-active" : ""
                }`}
              style={{
                padding: "8px",
                marginBottom: "5px",
                background:
                  activeMenu === "leaderboard"
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
              }}
            >
              <Link
                to="/leaderboard"
                style={{ textDecoration: "none", color: "white" }}
              >
                <FaListAlt style={{ marginRight: "5px" }} /> Leaderboard
              </Link>
            </li>

            {/* Profile Saya */}
            <li
              className={`menu-item ${activeMenu === "profile" ? "is-active" : ""
                }`}
              style={{
                padding: "8px",
                marginBottom: "5px",
                background:
                  activeMenu === "profile"
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
              }}
            >
              <Link
                to="/profile"
                style={{ textDecoration: "none", color: "white" }}
              >
                <FaUsers style={{ marginRight: "5px" }} /> Profile Saya
              </Link>
            </li>

            {/* Logout */}
            <li style={{ padding: "8px", marginBottom: "5px" }}>
              <button
                onClick={handleLogout}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  cursor: "pointer",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <BiLogOut style={{ marginRight: "5px" }} /> Keluar
              </button>
            </li>
          </ul>
        </aside>

        {/* Main Content Area */}
        <main style={{ flex: 1, padding: "2rem", paddingTop: "1rem" }}>
          <h1 className="title is-4">{title}</h1>
          {children}
        </main>
      </div>
    </div>
  );
};

export default LayoutUser;